import React, { Fragment, useState } from 'react'
import * as Styled from './UserProfile.styles'

const BadgesList = props => {
  const { badges, badgeUrls, badgeText, isSyndicated } = props
  const BRAND = process.env.BRAND || 'ARGOS'
  const isMobile = window.matchMedia('only screen and (max-width: 768px)').matches
  const [isHover, setHover] = useState(false)
  const enter = () => setHover(true)
  const leave = () => setHover(false)

  if (!badges.length) return null

  const showTextBox = isMobile || isHover
  return (
    <Styled.Container>
      {badges.map((badge, key) => {
        if (isSyndicated && badge === 'incentivizedReview') return null

        if (badge === 'incentivizedReview') {
          return (
            <Fragment key={key}>
              <Styled.Image
                isHover={isHover}
                Incentivized
                src={badgeUrls[BRAND][badge] || badge}
                alt={badgeText}
                lazy
                onMouseEnter={enter}
                onMouseLeave={leave}
              />
              {showTextBox && <Styled.TextBox> {badgeText} </Styled.TextBox>}
            </Fragment>
          )
        }

        return (
          <Styled.Badge key={key}>
            <Styled.Image src={badgeUrls[BRAND][badge] || badge} alt={badgeUrls[BRAND][badge] || ''} lazy />
          </Styled.Badge>
        )
      })}
    </Styled.Container>
  )
}

export default BadgesList
export { BadgesList }
